import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
const ScrollReveal = ({ children, className = '', threshold = 0.1, rootMargin = '0px 0px -50px 0px' }) => {
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
            }
        }, {
            threshold,
            rootMargin,
        });
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [threshold, rootMargin]);
    return (_jsx("div", { ref: ref, className: className, children: children }));
};
export default ScrollReveal;
